import { render } from "./PinkPlacemat.svg?vue&type=template&id=0b0cb2cb"
const script = {}
script.render = render

export default script